<template>
    <div class="graph-triple-panel">
        <div class="panel-row">
            <div class="panel-card panel-graph">
                <p class="panel-tit">{{ graphTitle }}</p>
                <disease-chart :option="graphOption" :height="chartHeight" />
            </div>
            <div class="panel-card panel-table">
                <p class="panel-tit">{{ tableTitle }}</p>
                <el-table
                    class="triple-table"
                    size="small"
                    :data="pageList"
                    :header-cell-style="headerCellStyle"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="60"
                        align="center"
                        :index="indexMethod"
                    />
                    <el-table-column prop="head" label="头实体" min-width="100" show-overflow-tooltip />
                    <el-table-column prop="relation" label="关系" width="80" show-overflow-tooltip />
                    <el-table-column prop="tail" label="尾实体" min-width="120" show-overflow-tooltip />
                    <el-table-column prop="source" label="来源" width="90" show-overflow-tooltip />
                </el-table>
                <el-pagination
                    class="page-wrap"
                    layout="prev, pager, next, jumper"
                    :current-page="pageInfo.pageNum"
                    :page-size="pageInfo.pageSize"
                    :total="pageInfo.total"
                    @current-change="changePage"
                />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import { buildGraphOption } from './buildGraphOption';

export default {
    name: 'GraphTriplePanel',
    components: {
        DiseaseChart,
    },
    props: {
        graphTitle: {
            type: String,
            default: '知识图谱',
        },
        tableTitle: {
            type: String,
            default: '三元组表格',
        },
        // { nodes, edges }
        graphData: {
            type: Object,
            default: () => ({ nodes: [], edges: [] }),
        },
        // [{ head, relation, tail, source }]
        triples: {
            type: Array,
            default: () => [],
        },
        // 固定每页条数
        pageSize: {
            type: Number,
            default: 15,
        },
        chartHeight: {
            type: String,
            default: '480px',
        },
    },
    data() {
        return {
            pageInfo: {
                pageNum: 1,
                pageSize: this.pageSize,
                total: 0,
            },
            headerCellStyle: {
                background: '#F5F7FA',
                color: '#303133',
                fontWeight: 'bold',
            },
        };
    },
    computed: {
        graphOption() {
            return buildGraphOption(this.graphData || { nodes: [], edges: [] });
        },
        pageList() {
            const { pageNum, pageSize } = this.pageInfo;
            const start = (pageNum - 1) * pageSize;
            return (this.triples || []).slice(start, start + pageSize);
        },
    },
    watch: {
        pageSize(val) {
            this.pageInfo.pageSize = val;
            this.pageInfo.pageNum = 1;
        },
        triples: {
            immediate: true,
            handler(list) {
                const total = (list || []).length;
                this.pageInfo.total = total;
                const maxPage = Math.max(1, Math.ceil(total / this.pageInfo.pageSize) || 1);
                if (this.pageInfo.pageNum > maxPage) {
                    this.pageInfo.pageNum = maxPage;
                }
            },
        },
    },
    methods: {
        indexMethod(index) {
            return (this.pageInfo.pageNum - 1) * this.pageInfo.pageSize + index + 1;
        },
        changePage(page) {
            this.pageInfo.pageNum = page;
        },
    },
};
</script>

<style lang="less" scoped>
.graph-triple-panel {
    .panel-row {
        display: flex;
        gap: 16px;
        align-items: stretch;
    }

    .panel-card {
        flex: 1 1 0;
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;
    }

    .panel-tit {
        margin: 0 0 10px;
        font-size: 14px;
        font-weight: bold; 
        line-height: 20px;
    }

    .triple-table {
        width: 100%;
    }

    .page-wrap {
        margin-top: 12px;
    }
}
</style>
